<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="8">
                <h2
                    style="
                        font-weight: 700;
                        color: rgb(0, 0, 0);
                        font-size: 18px;
                        line-height: 26px;
                    "
                >
                    Employee Feedback
                </h2>
            </b-col>
            <b-col>
                <div class="mr-3">
                    <eb-select
                        :options="surveyList"
                        label="title"
                        v-model="survey"
                        :selected="selectedSurvey"
                        @input="onChangeSurvey"
                        placeholder="Select Survey"
                    ></eb-select>
                </div>
            </b-col>
        </b-row>
        <b-card class="card-wrap" border-variant="info">
            <div>
                <b-table
                    style="border-radius: 12px"
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    responsive
                    class="tableRadius"
                    :items="feedbackList"
                    :fields="feedbackColumns"
                    :per-page="perPage"
                    :filter="filter"
                    thead-class="header"
                    show-empty
                    :busy="loading"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template slot="cell(action)" slot-scope="data">
                        <div class="inline_btnTable">
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                variant="primary"
                                @click="viewFeedback(data.item)"
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </div>
        </b-card>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "Feedback",
    components: {
        ComponentHeader,
        ebSelect,
    },
    data() {
        return {
            loading: false,
            perPage: 10,
            currentPage: 1,
            filter: "",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            sortBy: "submittedDate",
            sortDesc: true,
            feedbackColumns: [
                {
                    key: "name",
                    label: "Name",
                    sortable: true,
                },
                {
                    key: "submittedDate",
                    label: "Submitted Date",
                    sortable: true,
                },
                {
                    key: "action",
                },
            ],
            id: "",
            selectedSurvey: "",
            survey: "",
        };
    },
    computed: {
        ...mapState({
            feedbackListData: (state) => state.survey.employeeList,
            questionList: (state) => state.survey.questionList,
        }),
        surveyList() {
            return (
                this.questionList?.data?.map((obj) => {
                    let arrayObj = {
                        _id: obj._id,
                        title: obj.title,
                    };
                    return arrayObj;
                }) || []
            );
        },
        feedbackList() {
            return (
                this.feedbackListData?.data?.map((obj) => {
                    let arrayObj = {
                        _id: obj.userId,
                        name:
                            (obj?.name?.first || "-") +
                            " " +
                            (obj?.name?.last || ""),
                        submittedDate: moment(obj.submitted).format(
                            "DD-MM-YYYY HH:mm:ss",
                        ),
                    };
                    return arrayObj;
                }) || []
            );
        },
    },
    methods: {
        onChangeSurvey(e) {
            this.loading = true;
            this.selectedSurvey = e;
            this.id = e?._id;
            this.$store
                .dispatch("survey/employeeFeedbackList", this.id)
                .then(() => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        async getSurveyList() {
            this.loading = true;
            await this.$store
                .dispatch("survey/fetchQuestionSet")
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        async getFeedbackData(e) {
            this.currentPage = e;
            await this.getFeedbackList();
        },
        viewFeedback(data) {
            this.$router.push({
                name: "View Employee Feedback",
                params: { id: this.id, feedbackId: data?._id },
            });
        },
        async getFeedbackList() {
            this.loading = true;
            this.selectedSurvey = this.surveyList[0];
            this.id = this.surveyList[0]?._id;
            this.$store.dispatch("survey/employeeFeedbackList", this.id);
            this.loading = false;
        },
    },
    watch: {
        selectedSurvey(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.onChangeSurvey(newVal);
            }
        },
    },
    async mounted() {
        this.getSurveyList();
        this.getFeedbackList();
    },
};
</script>

<style scoped>
.card-wrap {
    margin: 20px;
}
</style>
